import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

export const phoneUtilInstance = PhoneNumberUtil.getInstance();

export const getE164FormatedPhone = (phone: any): string | null => {
    PhoneNumberUtil;
    let num = null;
    try {
        num = phoneUtilInstance.format(
            phoneUtilInstance.parseAndKeepRawInput(phone),
            PhoneNumberFormat.E164
        );
    } catch (e) {}
    return num;
};

export const isValidE164Format = (phoneNumber: string) => {
    // Regex to valid user input
    const regex = /(\+)\d*\.?\d*$/;
    if (regex.test(phoneNumber)) {
        // Evaluate if E164 format
        const phone = getE164FormatedPhone(phoneNumber);
        return phone ? true : false;
    }
    return false;
};

export const isValidPhoneNumber = (phoneNumber: string) => {
    // Regex to valid user input
    const regex = /^\+(?:[0-9] ?){7,14}[0-9]$/;
    if (regex.test(phoneNumber)) {
        try {
            return phoneUtilInstance.isValidNumber(
                phoneUtilInstance.parseAndKeepRawInput(phoneNumber)
            );
        } catch (e) {}
    }
    return false;
};

export const isValidANumber = (phoneNumber: string) => {
    if(phoneNumber.charAt(0)==='+'){
        return isNumber(phoneNumber.substring(1))
    }
    return isNumber(phoneNumber)
};

export const isNumber = (value: string | number) => {
   return ((value != null) &&
           (value !== '') &&
           (value.toString().length>2) &&
           checkOnlyDigit(value.toString()));
};

export const checkOnlyDigit = (value: string) => {
    return /^[0-9]+$/.test(value);
}

export const e164FormatErrorMessage =
    "Phone number must be in e164 format (e.g +14157921445)";
